import { useCallback } from "react";
import {
  useDisableShippingCost,
  useEnableShippingCost,
} from "../mutations/useStatusShippingCostToggle.mutation";

export const useShippingCostStatusToggle = () => {
  const disableMutation = useDisableShippingCost();
  const enableMutation = useEnableShippingCost();

  const handleEnable = useCallback(
    (id: string) => {
      enableMutation.mutate(id);
    },
    [enableMutation],
  );

  const handleDisable = useCallback(
    (id: string) => {
      disableMutation.mutate(id);
    },
    [disableMutation],
  );

  return {
    handleDisable,
    isDisabling: disableMutation.isPending,
    handleEnable,
    isEnabling: enableMutation.isPending,
  };
};
